const columnData = [
  {
    header: "سال زراعی",
    accessorKey: "crop_year_name",
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span> مبلغ <span className="text-blue-600">(تومان)</span></span>
      </div>
    ),
    accessorKey: "price",
    cell: (cell: any) => <div>{cell.getValue().toLocaleString()} تومان</div>,
  },
  {
    header: "کشاورز",
    accessorKey: "farmer_name",
    cell: (cell: any) => <div>{cell.getValue() || "نامشخص"}</div>,
  },
  {
    header: () => (
      <div className="flex items-center gap-1">
        <span>نوع پرداخت</span>
      </div>
    ),
    accessorKey: "payment_reason_name",
    cell: (cell: any) => <div>{cell.getValue() || "نامشخص"}</div>,
  },
  {
    header: "تاریخ ثبت",
    accessorKey: "created_at",
  },
];
export default columnData;
